import './LoadingOrbitalSpinner.scss';

const LoadingOrbitalSpinner = () => (
    <div className="loading-orbital-spinner-container">
        <div className="loading-orbital-spinner-logo" />
    </div>
);

export const orbitalSpinner = () => {
    const container = document.createElement('div');
    container.className = 'loading-orbital-spinner-container';
    const logo = document.createElement('div');
    logo.className = 'loading-orbital-spinner-logo';
    container.appendChild(logo);
    return container;
};

export default LoadingOrbitalSpinner;
